<div class="bg-white h-full">
    <!-- Header -->
    <div class="px-5 py-4 border-b border-gray-100">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
                <div class="w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center">
                    <i class="fa-solid fa-coins text-white text-lg"></i>
                </div>
                <h2 class="text-lg font-semibold text-gray-900">{{ 'CREDITS_INFO.TITLE' | translate }}</h2>
            </div>
            <button (click)="close()"
                    class="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                <i class="fa-solid fa-xmark text-gray-500"></i>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="px-5 py-5 space-y-5 max-h-[70vh] overflow-y-auto">

        <!-- Main explanation -->
        <div class="bg-amber-50 border border-amber-200 rounded-xl p-4">
            <div class="flex gap-3">
                <div class="flex-shrink-0">
                    <i class="fa-solid fa-globe text-amber-600 text-xl mt-0.5"></i>
                </div>
                <div>
                    <h3 class="font-semibold text-amber-900 mb-1">{{ 'CREDITS_INFO.GLOBAL_CREDITS_TITLE' | translate }}</h3>
                    <p class="text-sm text-amber-800 leading-relaxed">
                        {{ 'CREDITS_INFO.GLOBAL_CREDITS_DESCRIPTION' | translate }}
                    </p>
                </div>
            </div>
        </div>

        <!-- How credits work -->
        <div>
            <h3 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <i class="fa-solid fa-lightbulb text-amber-500"></i>
                {{ 'CREDITS_INFO.HOW_CREDITS_WORK_TITLE' | translate }}
            </h3>
            <div class="space-y-3">
                <div class="flex gap-3 items-start p-3 bg-gray-50 rounded-lg">
                    <span class="w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0">1</span>
                    <p class="text-sm text-gray-700">{{ 'CREDITS_INFO.HOW_STEP_1' | translate }}</p>
                </div>
                <div class="flex gap-3 items-start p-3 bg-gray-50 rounded-lg">
                    <span class="w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0">2</span>
                    <p class="text-sm text-gray-700">{{ 'CREDITS_INFO.HOW_STEP_2' | translate }}</p>
                </div>
                <div class="flex gap-3 items-start p-3 bg-gray-50 rounded-lg">
                    <span class="w-6 h-6 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0">3</span>
                    <p class="text-sm text-gray-700">{{ 'CREDITS_INFO.HOW_STEP_3' | translate }}</p>
                </div>
            </div>
        </div>

        <!-- Billing cycle info -->
        <div>
            <h3 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <i class="fa-solid fa-calendar-check text-blue-500"></i>
                {{ 'CREDITS_INFO.BILLING_CYCLE_TITLE' | translate }}
            </h3>
            <div class="bg-blue-50 border border-blue-200 rounded-xl p-4">
                <p class="text-sm text-blue-800 leading-relaxed">
                    {{ 'CREDITS_INFO.BILLING_CYCLE_DESCRIPTION' | translate }}
                </p>
            </div>
        </div>

        <!-- Credits vs Plan -->
        <div>
            <h3 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <i class="fa-solid fa-layer-group text-purple-500"></i>
                {{ 'CREDITS_INFO.CREDITS_VS_PLAN_TITLE' | translate }}
            </h3>
            <div class="space-y-3">
                <div class="flex gap-3 items-start p-3 bg-purple-50 border border-purple-100 rounded-lg">
                    <i class="fa-solid fa-file-invoice text-purple-500 mt-0.5"></i>
                    <div>
                        <span class="font-medium text-purple-900 text-sm">{{ 'CREDITS_INFO.PLAN_CREDITS_LABEL' | translate }}</span>
                        <p class="text-sm text-purple-700 mt-1">{{ 'CREDITS_INFO.PLAN_CREDITS_DESC' | translate }}</p>
                    </div>
                </div>
                <div class="flex gap-3 items-start p-3 bg-amber-50 border border-amber-100 rounded-lg">
                    <i class="fa-solid fa-coins text-amber-500 mt-0.5"></i>
                    <div>
                        <span class="font-medium text-amber-900 text-sm">{{ 'CREDITS_INFO.PURCHASED_CREDITS_LABEL' | translate }}</span>
                        <p class="text-sm text-amber-700 mt-1">{{ 'CREDITS_INFO.PURCHASED_CREDITS_DESC' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tip -->
        <div class="bg-green-50 border border-green-200 rounded-xl p-4">
            <div class="flex gap-3">
                <i class="fa-solid fa-circle-check text-green-600 text-lg flex-shrink-0 mt-0.5"></i>
                <div>
                    <span class="font-semibold text-green-900 text-sm">{{ 'CREDITS_INFO.TIP_TITLE' | translate }}</span>
                    <p class="text-sm text-green-800 mt-1 leading-relaxed">{{ 'CREDITS_INFO.TIP_DESCRIPTION' | translate }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="px-5 py-4 border-t border-gray-100">
        <button (click)="close()"
                class="w-full py-2.5 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-medium rounded-xl transition-all">
            {{ 'CREDITS_INFO.GOT_IT' | translate }}
        </button>
    </div>
</div>
